import React from 'react';
import { IconButton } from '~/components';

function FilterButton(props) {
  return <IconButton tooltip="Filters" icon="sliders-h" {...props} />;
}

export default FilterButton;
